<template>
  <div>
    <div id="cover-image">
      <img
        class="cover"
        :src="require('@/assets/background-student-profile.png')"
        alt
      />
      <div id="img-frame" class="text-center mb-1">
        <img
          class="photo"
          v-lazy="{
            src: photo,
            error: onError(),
            loading: require('@/assets/Rolling-1s-200px_2.svg')
          }"
        />
      </div>
    </div>
    <div class="text-center">
      <span>{{ profile ? profile.teacher_code : '-' }}</span>
      <h3
        class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
      >
        {{ profile ? profile.full_name_en : '-' }}
      </h3>
    </div>
    <ts-card-wrapper>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span>
            {{ $t('homePage.nameKh') }}
          </span>
          <p class="pull-right">
            {{ profile.full_name_kh ? profile.full_name_kh : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.sex') }}
          </span>
          <p class="pull-right">
            {{
              profile.gender ? (profile.gender == 1 ? 'Male' : 'Female') : '-'
            }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.dateOfBirth') }}
          </span>
          <p class="pull-right">{{ profile.dob ? profile.dob : '-' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.phoneNumber') }}
          </span>
          <p class="pull-right">{{ profile.phone ? profile.phone : '-' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.email') }}
          </span>
          <p class="pull-right">{{ profile.email ? profile.email : '-' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.educationLevel') }}
          </span>
          <p class="pull-right">
            {{ profile.education_level ? profile.education_level : '-' }}
          </p>
        </li>
      </ul>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'teacher-profile',
  data() {
    return {
      saving: false,
      fileChange: false,
      file: require('@/assets/user_default.png')
    }
  },
  computed: {
    ...mapState('home/teacher', ['profile']),
    photo() {
      if (this.profile.photo) {
        return this.profile.photo
      }
      return this.file
    }
  },
  methods: {
    onError() {
      event ? (event.target.src = this.file) : ''
    }
  }
}
</script>
<style lang="css" scoped>
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 10px 0 10px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -30%;
}
#img-frame .photo {
  width: 146px;
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
